import {
	type PoListCorrectionsData,
	poGetCorrections,
	poListCorrectionFilterOptions,
	poListCorrections
} from '@repo/sdk/gen'
import { zPoListCorrectionsData } from '@repo/sdk/zod'
import { queryOptions } from '@tanstack/react-query'
import { makeQueryKeys } from '@/lib/query-keys'

export function pendingCorrectionsCountQueryOptions() {
	return queryOptions({
		queryKey: makeQueryKeys.po.pendingCorrectionsCount(),
		queryFn: async ({ signal }) => {
			const response = await poListCorrections({
				body: {
					filters: { status: ['pending'] },
					limit:
						zPoListCorrectionsData.shape.body.shape.limit
							.unwrap()
							.unwrap().minValue ?? undefined
				},
				signal
			})
			return response.meta.total
		},
		refetchInterval: 30_000
	})
}

export function correctionsListQueryOptions(
	body: PoListCorrectionsData['body']
) {
	return queryOptions({
		queryKey: makeQueryKeys.po.correctionsIndex(body),
		queryFn: ({ signal }) => poListCorrections({ body, signal }),
		placeholderData: (previous) => previous
	})
}

export function correctionDetailQueryOptions(id: string) {
	return queryOptions({
		queryKey: makeQueryKeys.po.correctionDetail(id),
		queryFn: ({ signal }) => {
			return poGetCorrections({
				body: { filters: { ids: [id] } },
				signal
			})
		}
	})
}

export function correctionFilterOptions(runId?: string) {
	return queryOptions({
		queryKey: makeQueryKeys.po.correctionFilters(runId),
		queryFn: async ({ signal }) => {
			const response = await poListCorrectionFilterOptions({
				body: { filters: { runId } },
				signal
			})
			return response.data
		}
	})
}
